<!--
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-11-28 14:50:44
 * @LastEditors: susj
 * @LastEditTime: 2020-11-28 14:59:45
-->
<template>
  <svg class="icon" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>
<script>
const SVG_NAME = 'svg-icon';
export default {
  name: SVG_NAME,
  props: {
    iconClass: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName() {
      return `#icon${this.iconClass}`;
    },
  },
};
</script>
